import React from "react";
import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import useNotificationSetting from "./useNotificationSetting";

/**
 * When to warn a customer their plan is about to lapse, and what to say.
 *
 * Worth knowing while editing this: the warning is sent by the daily expiry sweep, and no OS
 * cron runs `php artisan schedule:run` yet - so on an environment without the crontab
 * fragment installed, nothing configured here will actually go out.
 */
const NotificationSetting = ({ handleClose }) => {
  const { formik, isSaving, isFetching, getFieldError, handleReset } =
    useNotificationSetting(handleClose);

  if (isFetching) {
    return <p className="pro-mb-0">Loading…</p>;
  }

  return (
    <div>
      <h5 className="pro-ttl pro-mb-4">Expiry Warning</h5>

      <Input
        label={"Days before expiry"}
        type="number"
        id="days_before"
        name="days_before"
        className={`pro-input lg ${getFieldError("days_before") && " error"}`}
        {...formik.getFieldProps("days_before")}
        error={getFieldError("days_before")}
        errorMessage={getFieldError("days_before")}
      />

      <Input
        label={"Title"}
        type="text"
        id="title"
        name="title"
        className={`pro-input lg ${getFieldError("title") && " error"}`}
        {...formik.getFieldProps("title")}
        error={getFieldError("title")}
        errorMessage={getFieldError("title")}
      />

      <Input
        label={"Title (Arabic)"}
        type="text"
        id="alias_title"
        name="alias_title"
        className={`pro-input lg ${getFieldError("alias_title") && " error"}`}
        {...formik.getFieldProps("alias_title")}
        error={getFieldError("alias_title")}
        errorMessage={getFieldError("alias_title")}
      />

      <div className="input-wrap pro-mb-4">
        <label htmlFor="message" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Message
        </label>
        <textarea
          id="message"
          name="message"
          rows={3}
          className={`pro-input lg ${getFieldError("message") && " error"}`}
          {...formik.getFieldProps("message")}
        />
        {getFieldError("message") && (
          <span className="error-text">{getFieldError("message")}</span>
        )}
      </div>

      <div className="input-wrap pro-mb-4">
        <label
          htmlFor="alias_message"
          className="pro-font-sm pro-mb-1 pro-fw-medium"
        >
          Message (Arabic)
        </label>
        <textarea
          id="alias_message"
          name="alias_message"
          rows={3}
          className={`pro-input lg ${getFieldError("alias_message") && " error"}`}
          {...formik.getFieldProps("alias_message")}
        />
        {getFieldError("alias_message") && (
          <span className="error-text">{getFieldError("alias_message")}</span>
        )}
      </div>

      <div className="pro-check-box pro-py-2 pro-mb-3">
        <div className="form-check form-switch">
          <input
            className="form-check-input cursor-pointer"
            type="checkbox"
            role="switch"
            id="setting_status"
            checked={Boolean(formik.values.status === 1)}
            onChange={(e) =>
              formik.setFieldValue("status", e?.target?.checked ? 1 : 2)
            }
          />
          <label htmlFor="setting_status" className="pro-check-label">
            Send expiry warnings
          </label>
        </div>
      </div>

      {/* Reset sits apart from Cancel/Save - all three as one right-aligned row reads as
          three ways to leave, when only two of them close the modal. */}
      <div className="pro-d-flex pro-items-center pro-justify-between">
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleReset}
          disabled={isSaving}
        >
          Reset
        </Button>

        <div className="pro-d-flex">
          <Button className={"pro-btn-link lg pro-px-5"} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className={`pro-btn-primary lg pro-ms-3`}
            type="submit"
            onClick={formik.handleSubmit}
            disabled={isSaving}
          >
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotificationSetting;
